import React from 'react'
import styles from './GalleryViewer.scss'
import { Gallery } from 'common/Gallery'
import { Postcard } from 'common/Postcard'
import blockSizes from '../../../App/blockSizes.scss'
import { photoLarge } from 'lib/urlHelpers'
import { showGallery } from 'features/gallery/showGallery'
import { FullWidthImageViewer } from './FullWidthImageViewer'

export const GalleryViewer = ({ block }) => {
  const data = block.getData()
  const caption = data.get('caption')
  const imageIds = data.get('imageIds', [])
  const displayAsPostcard = data.get('displayAsPostcard') && imageIds.length > 1
  const postcardLayout = data.get('postcardLayout')
  const canEmbiggen = displayAsPostcard || imageIds.length === 1
  const size = canEmbiggen ? data.get('size', 'normalBlock') : 'normalBlock'
  const minAspect = data.get('minAspect', null)

  if (!imageIds || imageIds.length === 0) {
    return null
  }

  const postcardImageSpec = postcardLayout
    ? { layout: postcardLayout }
    : { srcs: imageIds.map(id => `/photos/large/${id}.jpg`) }

  const handlePostcardClick = (image) => {
    const imageId = parseInt(image.src.match(/large\/(\d+)/)[1])
    const photos = imageIds.map(id => ({ id }))
    showGallery({ photos, readonly: true, defaultActive: imageIds.indexOf(imageId) })
  }

  return (
    <div className={blockSizes[size]}>
      <div className={styles.GalleryViewer}>
        {displayAsPostcard
          ? <Postcard disableFilmstrip clickableImages onImageClick={handlePostcardClick} edit={false} {...postcardImageSpec} />
          : <GalleryOrSingleImage imageIds={imageIds} minAspect={minAspect} yCenter={data.get('yCenter')} big={size === 'bigBlock'} />
        }
        {caption && <figcaption className={styles.caption}>{caption}</figcaption>}
      </div>
    </div>
  )
}

const GalleryOrSingleImage = ({ imageIds, yCenter, big = false, minAspect }) => {
  if (imageIds.length === 1) {
    return big
      ? <FullWidthImageViewer src={photoLarge(imageIds[0])} yCenter={yCenter} />
      : <div className={big ? styles.singleImgBig : styles.singleImg}><img src={photoLarge(imageIds[0])} /></div>
  } else {
    return <Gallery focusable imageIds={imageIds} minAspect={minAspect} />
  }
}
